__turbopack_context__.v({
  "container": "BrowsePlansCta-module-scss-module__XSJtpa__container",
  "fade": "BrowsePlansCta-module-scss-module__XSJtpa__fade",
  "fade-slide": "BrowsePlansCta-module-scss-module__XSJtpa__fade-slide",
  "open-from-center": "BrowsePlansCta-module-scss-module__XSJtpa__open-from-center",
  "spin": "BrowsePlansCta-module-scss-module__XSJtpa__spin",
  "text": "BrowsePlansCta-module-scss-module__XSJtpa__text",
});
